import { markUserNuxAsSeen } from '../services/UserService';
import { AD_IDS, SIDEBAR_AD_IDS, nuxKeyFor } from './adKeys';

const sent = new Set();

/**
 * Write each `seen_nux_json` key at most once per page load, skipping any the account already has.
 * Server-only on purpose: updating `diffitUser` would re-run every slot's selection and blink the
 * card. The write takes effect from the next page load, and the server merges top-level keys.
 */
const writeOnce = (diffitUser, patch) => {
  const fresh = Object.keys(patch).filter(
    (key) => !diffitUser?.seen_nux_json?.[key] && !sent.has(key)
  );
  if (!diffitUser?.id || !fresh.length) return;
  fresh.forEach((key) => sent.add(key));
  markUserNuxAsSeen(
    diffitUser.id,
    Object.fromEntries(fresh.map((key) => [key, patch[key]])),
    () => {}
  ).catch(() => fresh.forEach((key) => sent.delete(key)));
};

export const recordFirstSeen = (diffitUser, key) =>
  writeOnce(diffitUser, { [key]: { seen_at: new Date().toISOString() } });

export const retireAds = (diffitUser, ...adIds) =>
  writeOnce(
    diffitUser,
    Object.fromEntries(adIds.map((id) => [nuxKeyFor(id), { dismissed: true }]))
  );

/** After a curriculum alignment: the teacher no longer needs telling they can. */
export const retireTeacherCurriculumAnnouncement = (diffitUser) =>
  retireAds(diffitUser, AD_IDS.CURRICULUM_ANNOUNCEMENT, SIDEBAR_AD_IDS.CURRICULUM_ANNOUNCEMENT);

export const resetSentForTest = () => sent.clear();
